
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { isEqual } from 'lodash';
import PriceInput from './PriceInput.vue';
import { requiredRule } from '@/helpers/validation/requiredRule';
import { intRule } from '@/helpers/validation/intRule';

interface Value {
    _id: string;
    _valid: boolean,
    id?: string;
    from: number;
    price: number 
}

interface CurrentValue {
    _id: string;
    _valid: boolean,
    from: string;
    price: number 
}

@Component({
    components: {
        PriceInput
    }
})
export default class PrintPriceLevel extends Vue {
    @Prop({
        type: Object,
        default: null,
    })
    public value!: Value|null;
    @Prop({
        type: String,
        required: false,
        default: 0,
    })
    public prev!: string;
    public currentValue: CurrentValue = null as unknown as CurrentValue;
    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    public disabled!: boolean;

    get fromRules() {
        return [ 
            requiredRule, 
            intRule, 
            (v: string) => !this.prev || Number.parseInt(v) > Number.parseInt(this.prev) || `Ilość musi być większa od ${this.prev}`,
            (v: string) => Number.parseInt(v) > 1 || `Ilość musi być większa od 1` 
        ];
    }
    public priceRules = [ requiredRule ];

    @Watch('value', {
        immediate: true
    })
    public valueChange() {
        const value = this.value || {
            from: null,
            price: null
        };

        if (!isEqual(this.currentValue, value)) {
            Vue.set(this, 'currentValue', { ...value, from: value.from?.toString() || '' });
        }
    }

    @Watch('currentValue', {
        deep: true,
    })
    public currentValueChange() {
        if (!isEqual(this.currentValue, this.value) && this.validate()) {
            this.$emit('input', { ...this.currentValue });
        }
        if (this.currentValue.from && !this.currentValue.from?.match(/^[0-9]*$/)) {
            Vue.nextTick(() => 
                this.currentValue.from = this.currentValue.from.replace(/[^0-9]/g, '')
            );
        }

        if (this.currentValue.from && this.currentValue.from.match(/^0+/)) {
            Vue.nextTick(() => 
                this.currentValue.from = this.currentValue.from.replace(/^0+/, '')
            );
        }
    }

    @Watch('prev')
    public prevChanged() {
        (this.$refs.from as any).validate(true);
    }

    public fromKeydown(e: KeyboardEvent) {
        if ((e.shiftKey || !e.key.match(/[0-9]/)) && e.key.length === 1 && !e.ctrlKey) {
            e.preventDefault();
        }
    }

    public validate() {
        const fromValid = (this.$refs.from as any).validate(true);
        const priceValid = (this.$refs.price as any).validate();
        return fromValid && priceValid;
    }
}
